import {
  HorizontalFlexbox,
  VerticalFlexbox,
} from "@src/shared/components/layout/Flexbox";
import { Skeleton } from "@src/shared/components/ui/skeleton";

export function CareProtocolOpportunityListSkeleton() {
  return (
    <VerticalFlexbox
      gap="md"
      className="rounded-card border border-border bg-surface p-card shadow-soft"
      aria-label="Loading care gaps"
      aria-busy="true"
    >
      {[0, 1, 2].map((i) => (
        <HorizontalFlexbox key={i} alignItems="center" className="gap-3">
          <Skeleton className="size-9 rounded-[9px]" />
          <VerticalFlexbox gap="sm" className="min-w-0 flex-1">
            <Skeleton className="h-4 w-44" />
            <Skeleton className="h-3 w-64 max-w-full" />
          </VerticalFlexbox>
        </HorizontalFlexbox>
      ))}
    </VerticalFlexbox>
  );
}
